import React from "react"
import styled from "styled-components"
import Input from "../Auth/Input"

// ======================
// 	🧱🧱 COMPONENT 🧱🧱
// ======================

const Delivery = ({
  children,
  pinLatLng = false,
  showManualAddressSection = false,
  errors,
  touched,
  handlePostalCodeChange = () => {},
}) => {
  return (
    <div>
      <Input
        light
        label="Recipient Name and Surname: "
        id="shipping_name"
        name="shipping_name"
        type="text"
        autoComplete="name"
        placeholder="Name and Surname"
        size="50"
        i={3}
        errors={errors}
        touched={touched}
      />
      <Input
        light
        label="Recipient Contact Number: "
        id="phone"
        name="phone"
        type="tel"
        autoComplete="tel"
        placeholder="000 000 0000"
        size="50"
        i={4}
        errors={errors}
        touched={touched}
      />
      <SearchInput>
        <Input
          light
          label="Address Search: "
          id="google_address_search"
          name="google_address_search"
          type="text"
          placeholder="🔎 Street address, business name etc..."
          size="50"
          i={5}
        />
      </SearchInput>
      <AddressInputsStyling visible={!!pinLatLng || showManualAddressSection}>
        <Input
          light
          label="Street Address: "
          id="address_1"
          name="address_1"
          type="text"
          placeholder="Street address"
          autoComplete="shipping street-address address-line1"
          size="50"
          i={6}
          errors={errors}
          touched={touched}
        />
        <Input
          light
          label="Company Name (Optional): "
          id="company"
          name="company"
          type="text"
          autoComplete="shipping organization"
          size="50"
          i={7}
          errors={errors}
          touched={touched}
        />
        <Input
          light
          label="Suburb (Optional): "
          id="address_2"
          name="address_2"
          type="text"
          autoComplete="shipping street-address address-line2"
          placeholder="Suburb"
          size="50"
          i={8}
          errors={errors}
          touched={touched}
        />
        <Input
          light
          label="City / Town: "
          id="city"
          name="city"
          type="text"
          autoComplete="shipping address-level2"
          placeholder="City"
          size="50"
          i={9}
          errors={errors}
          touched={touched}
        />
        <Input
          light
          label="Postal Code: "
          id="postcode"
          name="postcode"
          type="text"
          autoComplete="shipping postal-code"
          placeholder="0000"
          size="50"
          i={10}
          errors={errors}
          touched={touched}
          handleChange={handlePostalCodeChange}
        />
        {children}
      </AddressInputsStyling>
    </div>
  )
}
// ======================
// 	💅🏼💅🏼 STYLES 💅🏼💅🏼
// ======================
const AddressInputsStyling = styled.div`
  ${({ visible }) => (visible ? "" : "display: none;")}
`

const SearchInput = styled.div`
  margin: 10px 0px;
  padding: 10px;
  border: 1px solid #cfd5db;
  background: aliceblue;
  label {
    padding-top: 2px;
  }
`

export default Delivery
